function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M144.215,275.078c-26.301-53.008-32.506-101.363-17.944-139.841c7.625-20.147,20.848-36.489,37.87-48.026 c-1.344-0.046-2.685-0.073-4.02-0.073c-44.987,0-80.94,25.273-91.595,64.387c-8.98,32.956-0.01,72.425,25.936,114.141 c30.363,48.817,83.088,98.268,153.673,144.408C201.249,364.644,166.019,319.023,144.215,275.078z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M385.086,25.045c-42.308-8.039-86.818-0.554-129.025,21.643c-44.143-23.166-92.19-30.35-135.812-20.21 C76.742,36.589,41.166,62.53,20.077,99.522c-16.549,29.031-37.84,90.566,5.521,176.513c17.926,35.533,45.013,70.932,80.508,105.216 c38.734,37.412,87.653,73.614,145.399,107.599c1.407,0.828,2.981,1.242,4.557,1.242s3.151-0.413,4.557-1.242 c34.185-20.118,65.579-41.223,93.31-62.728c3.921-3.042,4.635-8.686,1.595-12.607c-3.041-3.921-8.687-4.634-12.606-1.595 c-25.895,20.081-55.092,39.828-86.855,58.744c-104.911-62.486-179-132.513-214.421-202.724 c-29.334-58.145-31.448-114.796-5.953-159.518c18.58-32.59,50.055-55.476,88.629-64.441c40.727-9.465,85.974-2.088,127.404,20.778 c2.703,1.492,5.981,1.492,8.684,0c39.78-21.955,81.738-29.581,121.327-22.06c36.813,6.994,68.217,26.812,88.431,55.802 c23.77,34.09,30.029,78.381,17.627,124.713c-14.729,55.025-55.306,112.492-117.342,166.187c-3.752,3.248-4.162,8.922-0.914,12.674 c3.247,3.752,8.922,4.161,12.674,0.914c64.767-56.058,107.28-116.616,122.942-175.129c13.796-51.537,6.606-101.127-20.245-139.637 C461.99,55.357,426.541,32.921,385.086,25.045z"
});

var SvgHeartOutline = function SvgHeartOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454545"
    },
    d: "M255.999,481.082c433.24-254.98,206.466-538.165,0-424.214 C49.534-57.082-177.24,226.103,255.999,481.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454545"
    },
    d: "M255.999,415.158c-74.542-47.582-130.055-98.879-161.536-149.493 c-25.947-41.717-34.916-81.185-25.937-114.141c10.656-39.114,46.609-64.387,91.596-64.387c22.488,0,46.248,6.553,68.712,18.951 l27.165,14.993l27.165-14.993c22.464-12.398,46.224-18.951,68.713-18.951c44.976,0,80.921,25.273,91.578,64.387 c8.978,32.958,0.011,72.429-25.934,114.146C386.045,316.286,330.535,367.579,255.999,415.158z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _ref2), _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart-outline.3646db39.svg";
export { ForwardRef as ReactComponent };